module.exports = __webpack_public_path__ + "static/media/siddharth-guntur-trip-13.487989b1.png";